import play from 'assets/playImagery/imagery-play.png';
import play2x from 'assets/playImagery/imagery-play@2x.png';
import play3x from 'assets/playImagery/imagery-play@3x.png';
import ImageCardWithCenteredContents from 'components/ImageCardWithCenteredContents';
import useTrackPageLoad from 'hooks/useTrackPageLoad';
import { DashboardContent } from 'pages/Dashboard';
import React from 'react';
import { useEventTracking } from 'state/eventTracking';
import ClaimPodcastButton from './ClaimPodcastButton';

type EmptyStateProps = {};

const EmptyState: React.FC<EmptyStateProps> = () => {
  const { trackClaimPodcastButtonClick } = useEventTracking();

  const srcSet = `${play} 1x, ${play2x} 2x, ${play3x} 3x`;

  useTrackPageLoad({ section: 'Play', page: 'EmptyState', state: 'Empty' });
  return (
    <DashboardContent maxWidth="md">
      <ImageCardWithCenteredContents
        heading="Unlock your podcast analytics"
        description="Claim your podcast to see how many people are listening & following it in Headliner’s podcast player."
        src={play}
        srcSet={srcSet}
      >
        <ClaimPodcastButton
          onPress={() =>
            trackClaimPodcastButtonClick('DashboardPlayEmptyState')
          }
        />
      </ImageCardWithCenteredContents>
    </DashboardContent>
  );
};
export default EmptyState;
